import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
const ChevronRight = ({ className }) => {
    return (_jsx("svg", { className: cn(className), xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", children: _jsx("path", { d: "M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" }) }));
};
export default ChevronRight;
